const getScreenBreakpoints = () => ({
  sm: {
    MIN: 0,
    MAX: 768,
  },
  md: {
    MIN: 769,
    MAX: 991,
  },
  lg: {
    MIN: 992,
  },
});

export { getScreenBreakpoints };
